import Vue from 'vue'
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
